import styled from '@emotion/styled';
import { List, Pagination, Stack } from '@mui/material';
import {
  FIELD_BACKGROUND,
  BASIC_BORDER_RADIUS,
  BASIC_BORDER_COLOR,
  BASE_FIELD_BACKGROUND_COLOR,
} from '../../themes/tokens';

export const SearchWrapper = styled(Stack)`
  padding: 16px;
  background-color: ${FIELD_BACKGROUND};
  border-radius: ${BASIC_BORDER_RADIUS};
  margin-bottom: 24px;
`;

export const StyledList = styled(List)`
  margin-top: 16px;
  padding: 0;
  border: 1px solid ${BASIC_BORDER_COLOR};
  background-color: ${BASE_FIELD_BACKGROUND_COLOR};
`;

export const StyledPagination = styled(Pagination)`
  .Mui-selected {
    background-color: ${BASE_FIELD_BACKGROUND_COLOR};
  }
`;
